import binanceWallet from '@binance/w3w-rainbow-connector-v2';
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  bitgetWallet,
  gateWallet,
  injectedWallet,
  metaMaskWallet,
  okxWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';

import { META } from 'consts';
import { WalletId } from 'types';

import { burritoWallet } from './burritoWallet';

type CreateWalletFn = Parameters<typeof connectorsForWallets>[0][number]['wallets'][number];

const wallets: Partial<Record<WalletId, CreateWalletFn>> = {
  injected: injectedWallet,
  metaMask: metaMaskWallet,
  walletConnect: walletConnectWallet,
  burrito: burritoWallet,
  binance: binanceWallet,
  bitget: bitgetWallet,
  okx: okxWallet,
  gate: gateWallet,
};

const appUrl = typeof window !== 'undefined' ? window.location.origin : '';

export const wowmaxParams = {
  projectId: '36021a31f8991210dd9064dc0d741101',
  appName: 'WOWMAX',
  appDescription: META.description,
  appUrl,
  appIcon: `${appUrl}/images/logo.png`,
};

export const WALLETS_IDS = Object.keys(wallets);

export const connectors = connectorsForWallets(
  [
    {
      groupName: 'Wallets',
      wallets: Object.values(wallets),
    },
  ],
  wowmaxParams
);
